<template>
<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <GroupForm v-if="group" :group="group" />
    <LoadingPage v-if="!group"/>
  </PageRowWrapper>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import GroupForm from '@/components/settings/users/groups/GroupForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'GroupEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    GroupForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      group: state => state.groups.groupById
    })
  },
  methods: {
    ...mapActions('groups', ['fetchById', 'cleanState'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  },
  destroyed () {
    this.cleanState()
  }
}
</script>
